import {DatePicker} from 'antd';
import moment from 'moment';
import {observer} from 'mobx-react-lite';
import {datetimeFormat} from '../../../config/moment';

const DateRangePicker = ({
  dateTimeFrom,
  dateTimeFromFormat = datetimeFormat,
  dateTimeTo,
  dateTimeToFormat = datetimeFormat,
  defaultDateFormat = datetimeFormat,
  showTime = true,
  showDefaultTimeRanges = false,
  ...props
}) => (
  <DatePicker.RangePicker
    defaultValue={[
      dateTimeFrom ? moment(dateTimeFrom, dateTimeFromFormat) : null,
      dateTimeTo ? moment(dateTimeTo, dateTimeToFormat) : null,
    ]}
    format={defaultDateFormat}
    showTime={showTime}
    ranges={showDefaultTimeRanges ? {
      '1h': [moment().subtract(1, 'hours'), moment()],
      '3h': [moment().subtract(3, 'hours'), moment()],
      '5h': [moment().subtract(5, 'hours'), moment()],
      '8h': [moment().subtract(8, 'hours'), moment()],
      '24h': [moment().subtract(24, 'hours'), moment()],
      '48h': [moment().subtract(48, 'hours'), moment()],
    } : undefined}
    {...props}
  />
);

export default observer(DateRangePicker);
